import { PRODUCT_IDS } from '@adsk/alloy-provider';

export const KEY_FIELD = 'key';

export const ID_FIELD = 'id';

export const DATE_FORMAT = 'MMMM D, YYYY';

export const DEBOUNCE_TIME_MS = 400;

export const ACCESS_LEVELS = {
  ACCOUNT_ADMIN: 'accountAdmin',
  ACS_PROJECT_ADMIN: 'acsProjectAdmin',
  EXECUTIVE: 'executive',
  NO_ACCESS: 'noAccess',
  PROJECT_ADMIN: 'projectAdmin',
  PROJECT_MEMBER: 'projectMember',
};

export const OP_STATUSES = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const PREDEFINED_PROJECT_ADMIN_SETTINGS_TABS_IDS = {
  PROJECT: 'project',
  LOCATIONS: 'locations',
  NOTIFICATIONS: 'notifications',
};

export const SERVICE_ACCESSES = {
  MEMBER: 'member',
  ADMIN: 'administrator',
  NONE: 'none',
};

export const SERVICE_STATUSES = {
  ACTIVE: 'active',
  ACTIVATING: 'activating',
  AVAILABLE: 'available',
  DEACTIVATING: 'deactivating',
  ACTIVATION_FAILED: 'activationFailed',
  DEACTIVATION_FAILED: 'deactivationFailed',
  INACTIVE: 'inactive',
};

export const SERVICES = {
  ASSETS: 'assets',
  COST_MANAGEMENT: 'costManagement',
  DESIGN_COLLABORATION: 'designCollaboration',
  DOCUMENT_MANAGEMENT: 'documentManagement',
  FIELD_MANAGEMENT: 'fieldManagement',
  INSIGHT: 'insight',
  MODEL_COORDINATION: 'modelCoordination',
  PROJECT_ADMIN: 'projectAdministration',
  PROJECT_MANAGEMENT: 'projectManagement',
  QUANTIFICATION: 'quantification',
};

export const SERVICES_PRODUCTS_MAP = [
  {
    service: SERVICES.PROJECT_MANAGEMENT,
    product: PRODUCT_IDS.BUILD,
  },
  {
    service: SERVICES.FIELD_MANAGEMENT,
    product: PRODUCT_IDS.BUILD,
  },
  {
    service: SERVICES.ASSETS,
    product: PRODUCT_IDS.BUILD,
  },
  {
    service: SERVICES.COST_MANAGEMENT,
    product: PRODUCT_IDS.COST,
  },
  {
    service: SERVICES.INSIGHT,
    product: PRODUCT_IDS.INSIGHT,
  },
  {
    service: SERVICES.DOCUMENT_MANAGEMENT,
    product: PRODUCT_IDS.DOCS,
  },
  {
    service: SERVICES.QUANTIFICATION,
    product: PRODUCT_IDS.TAKEOFF,
  },
  {
    service: SERVICES.DESIGN_COLLABORATION,
    product: PRODUCT_IDS.DESIGN_COLLABORATION,
  },
  {
    service: SERVICES.MODEL_COORDINATION,
    product: PRODUCT_IDS.MODEL_COORDINATION,
  },
  {
    service: SERVICES.PROJECT_ADMIN,
    product: PRODUCT_IDS.PROJECT_ADMINISTRATION,
  },
];

export const ASSIGNABLE_PRODUCTS_MAP = {
  [PRODUCT_IDS.BUILD]: PRODUCT_IDS.BUILD,
  [PRODUCT_IDS.COST]: PRODUCT_IDS.COST,
  [PRODUCT_IDS.INSIGHT]: PRODUCT_IDS.INSIGHT,
  [PRODUCT_IDS.DOCS]: PRODUCT_IDS.DOCS,
  [PRODUCT_IDS.TAKEOFF]: PRODUCT_IDS.TAKEOFF,
  [PRODUCT_IDS.DESIGN_COLLABORATION]: PRODUCT_IDS.DESIGN_COLLABORATION,
  [PRODUCT_IDS.MODEL_COORDINATION]: PRODUCT_IDS.MODEL_COORDINATION,
};

export const COMPONENT_VARIANTS = {
  PROJECT: 'project',
  ACCOUNT: 'account',
  TRIAL: 'trial',
};

export const CURRENCIES = [
  'USD',
  'ALL',
  'AED',
  'ANG',
  'AUD',
  'AZN',
  'BGN',
  'BRL',
  'BYR',
  'CAD',
  'CHF',
  'CNY',
  'CZK',
  'DKK',
  'EEK',
  'EUR',
  'GBP',
  'HKD',
  'HRK',
  'HUF',
  'IDR',
  'ILS',
  'INR',
  'IRR',
  'ISK',
  'JPY',
  'KGS',
  'KPW',
  'KRW',
  'KZT',
  'LTL',
  'LVL',
  'MKD',
  'MNT',
  'MYR',
  'NOK',
  'NZD',
  'PHP',
  'PKR',
  'PLN',
  'RON',
  'RSD',
  'RUB',
  'SAR',
  'SEK',
  'SGD',
  'THB',
  'TRL',
  'TWD',
  'UAH',
  'UZS',
  'VND',
  'YER',
  'ZAR',
];

export const TIME_ZONES = [
  'Pacific/Honolulu',
  'America/Juneau',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Denver',
  'America/Chicago',
  'America/New_York',
  'America/Indiana/Indianapolis',
  'Pacific/Pago_Pago',
  'Pacific/Midway',
  'America/Tijuana',
  'America/Chihuahua',
  'America/Mazatlan',
  'America/Guatemala',
  'America/Mexico_City',
  'America/Monterrey',
  'America/Regina',
  'America/Bogota',
  'America/Lima',
  'America/Caracas',
  'America/Halifax',
  'America/Guyana',
  'America/La_Paz',
  'America/Santiago',
  'America/St_Johns',
  'America/Sao_Paulo',
  'America/Argentina/Buenos_Aires',
  'America/Godthab',
  'Atlantic/South_Georgia',
  'Atlantic/Azores',
  'Atlantic/Cape_Verde',
  'Africa/Casablanca',
  'Europe/Dublin',
  'Europe/Lisbon',
  'Europe/London',
  'Africa/Monrovia',
  'Etc/UTC',
  'Europe/Amsterdam',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Budapest',
  'Europe/Copenhagen',
  'Europe/Ljubljana',
  'Europe/Madrid',
  'Europe/Paris',
  'Europe/Prague',
  'Europe/Rome',
  'Europe/Sarajevo',
  'Europe/Skopje',
  'Europe/Stockholm',
  'Europe/Vienna',
  'Europe/Warsaw',
  'Africa/Algiers',
  'Europe/Zagreb',
  'Europe/Athens',
  'Europe/Bucharest',
  'Africa/Cairo',
  'Africa/Harare',
  'Europe/Helsinki',
  'Europe/Istanbul',
  'Asia/Jerusalem',
  'Europe/Kiev',
  'Africa/Johannesburg',
  'Europe/Riga',
  'Europe/Sofia',
  'Europe/Tallinn',
  'Europe/Vilnius',
  'Asia/Baghdad',
  'Asia/Kuwait',
  'Europe/Minsk',
  'Africa/Nairobi',
  'Asia/Riyadh',
  'Asia/Tehran',
  'Asia/Muscat',
  'Asia/Baku',
  'Europe/Moscow',
  'Asia/Tbilisi',
  'Asia/Yerevan',
  'Asia/Kabul',
  'Asia/Karachi',
  'Asia/Tashkent',
  'Asia/Kolkata',
  'Asia/Colombo',
  'Asia/Kathmandu',
  'Asia/Almaty',
  'Asia/Dhaka',
  'Asia/Yekaterinburg',
  'Asia/Rangoon',
  'Asia/Bangkok',
  'Asia/Jakarta',
  'Asia/Novosibirsk',
  'Asia/Shanghai',
  'Asia/Chongqing',
  'Asia/Hong_Kong',
  'Asia/Krasnoyarsk',
  'Asia/Kuala_Lumpur',
  'Australia/Perth',
  'Asia/Singapore',
  'Asia/Taipei',
  'Asia/Ulaanbaatar',
  'Asia/Urumqi',
  'Asia/Irkutsk',
  'Asia/Tokyo',
  'Asia/Seoul',
  'Australia/Adelaide',
  'Australia/Darwin',
  'Australia/Brisbane',
  'Australia/Melbourne',
  'Pacific/Guam',
  'Australia/Hobart',
  'Pacific/Port_Moresby',
  'Australia/Sydney',
  'Asia/Yakutsk',
  'Pacific/Noumea',
  'Asia/Vladivostok',
  'Pacific/Auckland',
  'Pacific/Fiji',
  'Asia/Kamchatka',
  'Asia/Magadan',
  'Pacific/Majuro',
  'Pacific/Guadalcanal',
  'Pacific/Tongatapu',
  'Pacific/Apia',
  'Pacific/Fakaofo',
];

export const TRACK_EVENTS = {
  SCOPE: {
    LICENSE: 'licensing',
    PROJECT_ADMIN: 'project_admin',
    ACCOUNT_ADMIN: 'account_admin',
  },
  PAGE: {
    MEMBERS: 'members',
  },
  SOURCE: {
    COMPANIES_MODAL: 'companies',
    CREATE_PROJECT: 'create_project',
    INVITE_MEMBER: 'invite',
    MEMBER_PROFILE: 'member_profile',
    FILTER_DRAWER: 'filters',
    QUICK_ADD: 'quick-add',
  },
  NAME: {
    ACCESS_LEVEL: 'access_level',
    ADD: 'add',
    CANCEL: 'cancel',
    COMPANY: 'company',
    COMPLETE: 'complete',
    CLEAR: 'clear',
    CLOSE: 'close',
    CREATE: 'create',
    OPEN: 'open',
    PRODUCTS_ON: 'products.on',
    PRODUCTS_OFF: 'products.off',
    REMOVE_MEMBER: 'remove_member',
    RESEND_INVITE: 'resend_invite',
    ROLE: 'role',
    STATUS: 'status',
    START: 'start',
    SUBSCRIPTION_ASSIGN: 'subscription.assign',
    SUBSCRIPTION_CHANGE: 'subscription.change',
    SUBSCRIPTION_UNASSIGN: 'subscription.unassign',
  },
};

export const MEMBER_STATUS = {
  ACTIVE: 'active',
  PENDING: 'pending',
  DISABLED: 'disabled',
  NOT_INVITED: 'not_invited',
};

export const USER_ACCOUNT_OFFERING_TYPES = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
  TRIAL: 'trial',
  NONE: 'none',
};

export const TRIAL_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
};

export const SUBSCRIPTION_TYPES = {
  PAID: 'paid',
  TRIAL: 'trial',
  NONE: 'none',
};

export const SUBSCRIPTION_STATUSES = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
  DELINQUENT: 'delinquent',
};

export const TRADES = [
  'Architecture',
  'Communications',
  'Communications | Data',
  'Concrete',
  'Concrete | Cast-in-Place',
  'Concrete | Precast',
  'Construction Management',
  'Conveying Equipment',
  'Conveying Equipment | Elevators',
  'Demolition',
  'Earthwork',
  'Earthwork | Site Excavation & Grading',
  'Electrical',
  'Electrical Power Generation',
  'Electronic Safety & Security',
  'Equipment',
  'Equipment | Kitchen Appliances',
  'Exterior Improvements',
  'Exterior | Fences & Gates',
  'Exterior | Landscaping',
  'Exterior | Irrigation',
  'Finishes',
  'Finishes | Carpeting',
  'Finishes | Ceiling',
  'Finishes | Drywall',
  'Finishes | Flooring',
  'Finishes | Painting & Coating',
  'Finishes | Tile',
  'Fire Suppression',
  'Furnishings',
  'Furnishings | Casework & Cabinets',
  'Furnishings | Countertops',
  'Furnishings | Window Treatments',
  'General Contractor',
  'HVAC Heating, Ventilating, & Air Conditioning',
  'Industry-Specific Manufacturing Processing',
  'Integrated Automation',
  'Masonry',
  'Material Processing & Handling Equipment',
  'Metals',
  'Metals | Structural Steel / Framing',
  'Moisture Protection',
  'Moisture Protection | Roofing',
  'Moisture Protection | Waterproofing',
  'Openings',
  'Openings | Doors & Frames',
  'Openings | Entrances & Storefronts',
  'Openings | Glazing',
  'Openings | Roof Windows & Skylights',
  'Openings | Windows',
  'Owner',
  'Plumbing',
  'Pollution & Waste Control Equipment',
  'Process Gas & Liquid Handling, Purification, & Storage Equipment',
  'Process Heating, Cooling, & Drying Equipment',
  'Process Integration',
  'Process Integration | Piping',
  'Special Construction',
  'Specialties',
  'Specialties | Signage',
  'Utilities',
  'Water & Wastewater Equipment',
  'Waterway & Marine Construction',
  'Wood & Plastics',
  'Wood & Plastics | Millwork',
  'Wood & Plastics | Rough Carpentry',
  'Other',
];
